<template>
  <p
    v-show="text !== ''"
    :class="bemBlockMod(backgroundColor ? 'background-filled' : '')"
    :style="{
      'background-color': backgroundColor || '',
      color: color || '',
    }"
  >
    {{ text }}
  </p>
</template>

<script>
/**
 * The BaseSlotMessage builds a <p> message element
 * according to the configuration defined in the slotId prop, which is a SFCC Content Slot.
 * The Content Slot JSON must have the slotMessageData content & must be rendered in the page.
 */

/**
 * slotId Slot JSON Data
 * @typedef {object} slotMessageData
 * @property {boolean} enabledWeb True if message is enabled in web
 * @property {boolean} enabledApps True if message is enabled in apps
 * @property {string} [textColor] hex code for the text color
 * @property {string} [backgroundColor] hex code for the background color
 * @property {string} message Text message content
 */

import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseSlotMessage',

  mixins: [bemClassesMixin],

  props: {
    slotId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      backgroundColor: '',
      color: '',
      text: '',
    };
  },

  mounted() {
    this.buildMessage();
  },

  methods: {
    /**
     * Fill the component data attributes to build the Slot Message
     */
    buildMessage() {
      const slotData = this.getSlotData();
      if (!slotData?.enabledWeb) {
        return;
      }

      this.text = slotData.message;
      this.color = slotData.textColor;
      this.backgroundColor = slotData.backgroundColor;
    },
    /**
     * Get the slotId Slot JSON Data
     * @returns {slotMessageData|Object} slotId slot data
     */
    getSlotData() {
      const slotMessageElement = document.getElementById(this.slotId);
      if (!slotMessageElement) {
        return {};
      }

      let jsonText = slotMessageElement.textContent;

      // Remove Slot HTML comments
      jsonText = jsonText.replace(/<!--[\s\S]*?-->/g, '').trim();

      const { isEmpty } = require('../../common/utils/type');
      if (isEmpty(jsonText)) {
        return {};
      }

      try {
        return JSON.parse(jsonText);
      } catch (e) {
        console.error(`${this.slotId} does not have a valid JSON`);
        return {};
      }
    },
  },
};
</script>
